<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-divider v-bind="attrs" v-on="on"></v-divider>
      </template>
      <span>UD:{{ throttling }}</span>
    </v-tooltip>
    <v-container
      fluid
      class="ma-0 pa-0"
      v-if="(conexions_progress >= 0 && conexions_progress <= 99) || debug"
    >
      <v-row>
        <v-col cols="12">
          <v-progress-linear :value="conexions_progress" height="25" rounded>
            {{ Math.ceil(conexions_progress) }}%
          </v-progress-linear>
        </v-col>
      </v-row>
      <v-row v-if="debug">
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel v-for="(item, i) in items" :key="i">
              <v-expansion-panel-header>
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="4"> {{ get_title(item) }} </v-col>
                    <v-col cols="8" class="text--secondary">
                      <span class="overflow-x-auto">
                        {{ get_subtitle(item) }}
                      </span>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-textarea
                  full-width
                  rows="15"
                  solo
                  name="input-7-4"
                  label="Solo textarea"
                  :value="get_raw_data(item)"
                ></v-textarea>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Vuex from "vuex";
import { TradovateSocket } from "@/mixins/tradovateSocket";

export default {
  name: "TradovateBrokerConnector",
  components: {},
  mixins: [],
  props: {
    have_token: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      throttling: 0,
      reload_prev: 0,
      reload: 1,
      tradovate_wss: new Map(),
      users_data: [],
      plurals: {
        currency: "currencies",
        accountRiskStatus: "accountRiskStatuses",
        contractMaturity: "contractMaturities",
        orderStrategy: "orderStrategies",
        userProperty: "userProperties",
        property: "properties",
        userReadStatus: "userReadStatuses",
      },
      unique_by_alt_id: {},
      max_delay_reload: 20,
      delayed_reload: 0,
      emit_user_data_timeout: null,
      low_data_profile: true,
      req_data_profile: [
        "users",
        "accounts",
        "accountRiskStatuses",
        "userAccountAutoLiqs",
        "cashBalances",
        "positions",
        "orders",
        "executionReports",
        "fills",
        "contracts",
        "contractMaturities",
        "products",
        "exchanges",
      ],
      save_only_last: true,
      last_only: { cashBalance: "accountId", executionReport: "orderId" },
      user_data_interval: null,
      user_data_interval_ms: 250,
      items: [],
      debug_new: true,
      debug_item_types: ["position"],
      debug: false,
      mock: false,
    };
  },
  methods: {
    swap_conn(broker_conns) {
      this.close_diff_accounts(broker_conns);
      this.connect_ws_int(broker_conns);
      this.do_real_emit_user_data(true);
    },
    last_unique_items(items, pivot_attr) {
      let u = new Map();
      items?.sort((a, b) => a.id - b.id);
      items?.forEach((i) => {
        i.id = i[pivot_attr];
        u.set(i.id, i);
      });
      return Array.from(u.values());
    },
    remove_unused(user_data) {
      if (this.low_data_profile && user_data) {
        Object.keys(user_data).forEach((attr) => {
          if (!this.req_data_profile.includes(attr)) delete user_data[attr];
        });
      }
      if (this.save_only_last && user_data) {
        Object.keys(this.last_only).forEach((attr) => {
          let a = this.get_plural(attr);
          user_data[a] = this.last_unique_items(
            user_data[a],
            this.last_only[attr]
          );
        });
      }
    },
    get_title(tradovate_ws) {
      return `${tradovate_ws?.user_data?.users?.map((u) => u.name)}`;
    },
    get_subtitle(tradovate_ws) {
      let l = tradovate_ws?.user_data?.accounts;
      if (this.mock) {
        let test = [];
        for (let i = 0; i < 100; i++) test.push({ name: `test${i}` });
        l = test;
      }
      l = l?.map((u) => u.name);
      if (l) l = this.ST.short_list(l, 100);
      return `${l}`;
    },
    get_raw_data(tradovate_ws) {
      return JSON.stringify(tradovate_ws.user_data, null, 4);
    },
    get_plural(val) {
      if (this.plurals[val]) {
        return this.plurals[val];
      }
      return val + "s";
    },
    update_model(data, attr, entity) {
      let f = data[attr]?.find((o) => o.id == entity.id);
      if (f) {
        Object.assign(f, entity);
      }
    },
    debug_new_data(item) {
      if (
        this.debug_new &&
        this.debug_item_types.indexOf(item?.entityType) > -1
      ) {
        let now = new Date();
        if (this.debug)
          console.log(
            now.toLocaleString("es-MX"),
            now.getMilliseconds(),
            "new item",
            item.entityType,
            item
          );
      }
    },
    subscribe_user_sync(socket, keep_all_data = false) {
      let self = this;
      socket
        .subscribe({
          url: "user/syncrequest",
          body: { accounts: socket.manage_acc_ids },
          subscription: (item) => {
            if (item.users) {
              if (!keep_all_data) {
                this.remove_unused(item);
                if (this.debug) console.log("do not keep all data.");
              }
              socket.user_data = item;
              socket.user_data.positions.forEach((p) => {
                p.openPnL = 0;
              });
              self.reload += 1;
            } else {
              if (socket.user_data) {
                this.debug_new_data(item);
                try {
                  let attr = self.get_plural(item.entityType);
                  if (!socket.user_data[attr]) {
                    if (self.debug)
                      console.log(
                        "user_data has no key:",
                        socket.broker.id,
                        attr
                      );
                    return;
                  } else {
                    if (self.debug)
                      console.log(
                        `${item.eventType} obj in ${attr} with id ${item.entity?.id}`
                      );
                  }
                  if (
                    item.eventType != "Deleted" &&
                    Object.keys(this.last_only).includes(item.entityType)
                  ) {
                    item.entity.id =
                      item.entity[this.last_only[item.entityType]];
                    this.update_model(socket.user_data, attr, item.entity);
                  } else if (item.eventType == "Created") {
                    socket.user_data[attr]?.push(item.entity);
                  } else if (item.eventType == "Updated") {
                    this.update_model(socket.user_data, attr, item.entity);
                  }
                  if (item.eventType == "Deleted") {
                    socket.user_data[attr].splice(
                      socket.user_data[attr].findIndex(
                        (o) => o.id == item.entity.id
                      ),
                      1
                    );
                  }
                  self.reload += 1;
                } catch (error) {
                  console.log("Error WS change user_data", error);
                }
              }
            }
          },
        })
        .then(
          (cancel_sub) => {
            socket.user_data_unsuscribe = cancel_sub;
          },
          (err) => this.show_error_message(err)
        )
        .catch((err) => this.show_error_message(err));
    },
    close_ws(l) {
      l?.forEach((wss) => {
        wss.close();
        this.tradovate_wss.delete(wss.broker.id);
      });
    },
    close_diff_accounts(broker_conns) {
      broker_conns.forEach((b) => {
        let wss = this.tradovate_wss.get(b.broker.id);
        if (wss) {
          let diff = this.T.diff_array(wss.manage_acc_ids, b.account_ids);
          if (diff.size > 0) {
            wss.user_data_unsuscribe();
            this.close_ws([wss]);
          }
        }
      });
      let wss_b_ids = Array.from(this.tradovate_wss.values()).map(
        (ws) => ws.broker.id
      );
      let broker_b_ids = broker_conns.map((b) => b.broker.id);
      let disconnect = wss_b_ids.filter((x) => !broker_b_ids.includes(x));
      disconnect.forEach((d) => {
        let wss = this.tradovate_wss.get(d);
        this.close_ws([wss]);
      });
    },
    connect_ws_int(broker_conns) {
      if (this.debug) console.log("connect_ws_int", broker_conns);
      broker_conns.forEach((b) => {
        let socket;
        if (this.tradovate_wss.get(b.broker.id)) {
          socket = this.tradovate_wss.get(b.broker.id);
        } else {
          socket = new TradovateSocket({
            debugLabel: `${b.id}-ws`,
            debug: this.debug,
          });
          this.tradovate_wss.set(b.broker.id, socket);
          socket.broker = b.broker;
          socket.manage_acc_ids = b.account_ids;
        }
        if (this.debug)
          console.log("have a socket connected:", socket.connected);

        if (!socket.connected) {
          socket
            .connect(
              socket.get_wss_url(socket.broker.config_json.tradovate_url),
              socket.broker.config_json.tradovate_token
            )
            .then(
              (res) => {
                this.subscribe_user_sync(socket);
              },
              (rej) => {
                let message = {
                  message: `${socket.broker?.name} - ${rej?.d}`,
                };
                this.show_error_message(message);
              }
            );
        }
      });
      if (this.debug)
        console.log("wsss", Array.from(this.tradovate_wss.values()));
    },
    do_real_emit_user_data(force = false) {
      this.throttling = this.reload - this.reload_prev;
      if (this.reload_prev == this.reload && !force) {
        return;
      }
      this.reload_prev = this.reload;
      let now = new Date();
      if (this.debug)
        console.log(
          now.toLocaleString(),
          now.getMilliseconds(),
          "do_real_emit_user_data"
        );
      this.items = Array.from(this.tradovate_wss.values());
      this.$emit(
        "set_users_data",
        this.items.filter((v) => v.user_data).map((v) => v.user_data)
      );
    },
    emit_user_data() {
      if (this.delayed_reload > this.max_delay_reload) {
        console.log("delayed_reload", this.delayed_reload);
        this.do_real_emit_user_data();
        clearTimeout(this.emit_user_data_timeout);
        this.delayed_reload = 0;
        return;
      }
      if (this.emit_user_data_timeout) {
        clearTimeout(this.emit_user_data_timeout);
        this.delayed_reload += 1;
      }
      this.emit_user_data_timeout = setTimeout(() => {
        this.do_real_emit_user_data();
      }, this.user_data_interval_ms);
    },
    set_interval() {
      this.user_data_interval = setInterval(
        this.do_real_emit_user_data,
        this.user_data_interval_ms
      );
    },
    ...Vuex.mapActions(["show_error_message", "show_info_message"]),
  },
  computed: {
    conexions_progress() {
      if (this.reload < 0) return -1;
      let total = this.items?.length;
      let count = 0;
      if (total > 0) {
        this.items?.forEach((ws) => {
          if (ws.connected) count += 1;
          if (ws.user_data) count += 1;
        });
        return 100 * (count / (2 * total));
      } else return 0;
    },
    ...Vuex.mapState(["user_data"]),
  },
  watch: {},
  mounted() {
    if (this.debug) window.tradovate_wss = this.tradovate_wss;
    this.set_interval();
  },
  beforeDestroy() {
    if (this.user_data_interval) clearInterval(this.user_data_interval);
    if (this.debug) console.log("destroy tradovate websockets");
    this.close_ws(Array.from(this.tradovate_wss.values()));
    this.$emit("set_users_data", []);
  },
};
</script>
